const seoRoutes = [
  "/",
  "/about-us",
  "/blogs/aesthetic-ideas",
  "/blogs/beginners-guide",
  "/blogs/best-furniture-on-rent-in-gurgaon",
  "/blogs/buying-vs-renting",
  "/blogs/furniture-rentals",
  "/blogs/get-a-bed-on-rent-in-gurgaon",
  "/blogs/get-a-fridge-on-rent-in-gurgaon",
  "/blogs/rent-a-chair-in-gurgaon",
  "/blogs/rented-appliances-in-gurgaon",
  "/blogs/seasonal-selfcare",
  "/blogs/sofa-on-rent-in-gurgaon",
  "/blogs/study-table-on-rent-in-gurgaon",
  "/blogs/tips-for-renting-furniture",
  "/blogs/types-of-wood",
  "/blogs/upgrade-lifestyle",
  "/delhi",
  "/delhi/appliance",
  "/delhi/appliance/1.5-ton-haier-AC",
  "/delhi/appliance/1.5-ton-haier-AC/1.5-ton-haier-AC",
  "/delhi/appliance/Fire-TV-Stick-Lite",
  "/delhi/appliance/Fire-TV-Stick-Lite/fire-tv-stick-light",
  "/delhi/appliance/air-cooler",
  "/delhi/appliance/air-cooler/air-cooler",
  "/delhi/appliance/air-purifier",
  "/delhi/appliance/bed/haier-55-inch-4K-UHD-LED-TV-0-1",
  "/delhi/appliance/geyser",
  "/delhi/appliance/geyser/crompton-arno-neo",
  "/delhi/appliance/heater",
  "/delhi/appliance/induction",
  "/delhi/appliance/inverter",
  "/delhi/appliance/inverter/double-battery-inverter",
  "/delhi/appliance/inverter/single-battery-inverter",
  "/delhi/appliance/microwave",
  "/delhi/appliance/microwave/solo-microwave-0-6",
  "/delhi/appliance/refrigerator",
  "/delhi/appliance/refrigerator/double-door-refrigerator-0-9",
  "/delhi/appliance/refrigerator/single-door-refrigerator-0-9",
  "/delhi/appliance/ro",
  "/delhi/appliance/ro/Kent-ultra-storage-0-1",
  "/delhi/appliance/ro/Livpure-Allura-premia-water-purifier-0-1",
  "/delhi/appliance/television",
  "/delhi/appliance/television/led-32-inch-0-1",
  "/delhi/appliance/television/led-40-inch-0-9",
  "/delhi/appliance/washing-machine",
  "/delhi/appliance/washing-machine/semi_automatic_machine_6kg",
  "/delhi/appliance/washing-machine/washing-machine-fully-auto-top-load-0-6",
  "/delhi/expressDelivery",
  "/delhi/expressDelivery/chair/high-back-office-chair",
  "/delhi/expressDelivery/chair/wooden-chair-0-1",
  "/delhi/expressDelivery/heater-seasonal/Induction Cooktop",
  "/delhi/expressDelivery/sofa-prem/l-shape-sofa-cum-bed",
  "/delhi/expressDelivery/sofa/killim-beige-1-seater-sofa-0-1",
  "/delhi/expressDelivery/sofa/latte-2-seater-sofa-0-1",
  "/delhi/expressDelivery/sofa/pebble-grey-l-shaped-sofa-0-1",
  "/delhi/expressDelivery/sofa/sapphire-blue-1-seater-sofa-0-1",
  "/delhi/expressDelivery/sofa/single-futon-with-mattress-0-1",
  "/delhi/expressDelivery/storage/bookshelf-0-1",
  "/delhi/expressDelivery/table/4-seater-sheesham-dining-set",
  "/delhi/expressDelivery/table/6-seater-dining-table-0-1",
  "/delhi/expressDelivery/table/dressing-table-0-1",
  "/delhi/expressDelivery/table/wooden-bedside-table-0-1",
  "/delhi/expressDelivery/television/led-32-inch-0-1",
  "/delhi/expressDelivery/television/led-40-inch-0-9",
  "/delhi/expressDelivery/work-from-home/work-from-home-new-two",
  "/delhi/expressDelivery/work-from-home/work-from-home-package",
  "/delhi/furniture",
  "/delhi/furniture/bed",
  "/delhi/furniture/bed/arch-double-storage-bed-0-1",
  "/delhi/furniture/bed/arch-premium-double-storage-bed-0-1",
  "/delhi/furniture/bed/tuft-double-bed-0-1",
  "/delhi/furniture/bed/tuft-double-storage-bed-0-1",
  "/delhi/furniture/bed/tuft-double-storage-bed-0-2",
  "/delhi/furniture/bed/tuft-double-storage-bed-0-3",
  "/delhi/furniture/bed/tuft-single-storage-bed-0-1",
  "/delhi/furniture/bed/vega-double-bed-0-1",
  "/delhi/furniture/bed/vega-double-storage-bed-0-1",
  "/delhi/furniture/bed/vega-single-bed-0-1",
  "/delhi/furniture/chair",
  "/delhi/furniture/chair/FlexPro Chair",
  "/delhi/furniture/chair/abstract-wing-chair-0-1",
  "/delhi/furniture/chair/airflow_pro_office_chair",
  "/delhi/furniture/chair/evon-office-chair-0-1",
  "/delhi/furniture/chair/high-back-office-chair",
  "/delhi/furniture/chair/nitro-gt-gaming-chair",
  "/delhi/furniture/chair/wooden-chair-0-1",
  "/delhi/furniture/mattress",
  "/delhi/furniture/mattress/double-mattress-0-1",
  "/delhi/furniture/mattress/premium-double-mattress-0-1",
  "/delhi/furniture/mattress/premium-single-mattress-0-1",
  "/delhi/furniture/mattress/single-mattress-0-1",
  "/delhi/furniture/recliner",
  "/delhi/furniture/recliner/relaxPro-recliner-chair",
  "/delhi/furniture/sofa",
  "/delhi/furniture/sofa/cyan-l-shaped-sofa-0-1",
  "/delhi/furniture/sofa/killim-beige-1-seater-sofa-0-1",
  "/delhi/furniture/sofa/killim-beige-3-seater-sofa-0-1",
  "/delhi/furniture/sofa/killim-beige-5-seater-sofa-(3+1+1)-0-1",
  "/delhi/furniture/sofa/latte-1-seater-sofa-0-1",
  "/delhi/furniture/sofa/latte-2-seater-sofa-0-1",
  "/delhi/furniture/sofa/latte-3-seater-sofa-0-1",
  "/delhi/furniture/sofa/latte-4-seater-sofa-(2+1+1)-0-1",
  "/delhi/furniture/sofa/latte-5-seater-sofa-(3+1+1)-0-1",
  "/delhi/furniture/sofa/latte-5-seater-sofa-(3+2)-0-1",
  "/delhi/furniture/sofa/pebble-grey-l-shaped-sofa-0-1",
  "/delhi/furniture/sofa/sapphire-blue-1-seater-sofa-0-1",
  "/delhi/furniture/sofa/sapphire-blue-3-seater-sofa-0-1",
  "/delhi/furniture/sofa/sapphire-blue-5-seater-sofa-(3+1+1)-0-1",
  "/delhi/furniture/sofa/single-futon-with-mattress-0-1",
  "/delhi/furniture/sofa/sofa-cum-bed",
  "/delhi/furniture/storage",
  "/delhi/furniture/storage/bookshelf-0-1",
  "/delhi/furniture/storage/bookshelf-divider-0-1",
  "/delhi/furniture/storage/shoerack-0-1",
  "/delhi/furniture/storage/wardrobe-0-1",
  "/delhi/furniture/storage/wardrobe-with-mirror-0-1",
  "/delhi/furniture/table",
  "/delhi/furniture/table/4-seater-dining-set-0-1",
  "/delhi/furniture/table/4-seater-sheesham-dining-set",
  "/delhi/furniture/table/6-seater-dining-table-0-1",
  "/delhi/furniture/table/caramel-side-table-0-1",
  "/delhi/furniture/table/center-table-0-1",
  "/delhi/furniture/table/dressing-table-0-1",
  "/delhi/furniture/table/study-table-0-1",
  "/delhi/furniture/table/wenge-side-table-0-1",
  "/delhi/furniture/table/wooden-bedside-table-0-1",
  "/delhi/furniture/television/signature-series-console-1",
  "/delhi/package",
  "/delhi/package/appliances-package",
  "/delhi/package/appliances-package/appliances-only-1",
  "/delhi/package/bhk",
  "/delhi/package/bhk/1-bhk-essentials",
  "/delhi/package/bhk/1-bhk-furnitures-only-1",
  "/delhi/package/bhk/2-bhk-essentials",
  "/delhi/package/drawing-room-package",
  "/delhi/package/family",
  "/delhi/package/family/couple-cozy-premium-combo",
  "/delhi/package/family/couples-cozy-combo-affordable-1",
  "/delhi/package/family/family-essentials-1",
  "/delhi/package/living-room",
  "/delhi/package/living-room/affordable-living-room-combo",
  "/delhi/package/living-room/full-bedroom-furniture-affordable-1",
  "/delhi/package/living-room/full-bedroom-furniture-premium-1",
  "/delhi/package/living-room/premium-living-room-1",
  "/delhi/package/study-cool-combo-package",
  "/delhi/package/study-cool-combo-package/budget-friendly-living-combo-1",
  "/delhi/package/work-from-home",
  "/delhi/package/work-from-home/work-from-home-new-two",
  "/delhi/package/work-from-home/work-from-home-package",
  "/delhi/premium",
  "/delhi/premium/bed-prem",
  "/delhi/premium/bed-prem/Aura-Double-Bed",
  "/delhi/premium/bed-prem/Comso-Double-Bed",
  "/delhi/premium/bed-prem/Dream-Lux-Premium-Double-Bed",
  "/delhi/premium/bed-prem/Shirley-Double-Bed",
  "/delhi/premium/bed-prem/Somnia-Supreme-Premium-Double-Bed",
  "/delhi/premium/bed-prem/Teak-Cane-Double-Bed-Ratan",
  "/delhi/premium/bed-prem/Zenith-Premium-Double-Bed",
  "/delhi/premium/bed-prem/Ziva-Double-Bed",
  "/delhi/premium/chair-prem",
  "/delhi/premium/chair-prem/Premium-Cane-Cushioned-chair",
  "/delhi/premium/premium-mattress",
  "/delhi/premium/premium-mattress/Orthopedic-Mattress",
  "/delhi/premium/sofa-prem",
  "/delhi/premium/sofa-prem/Chesterfield-3-seater-Fabric-Sofa",
  "/delhi/premium/sofa-prem/Chesterfield-3-seater-Leather-Sofa",
  "/delhi/premium/sofa-prem/Dual-shade-Sofa",
  "/delhi/premium/sofa-prem/Premium-Eterna-Plush-Sofa",
  "/delhi/premium/sofa-prem/Urban-Elegance-Sofa",
  "/delhi/premium/sofa-prem/aegean-chase-sofa-1",
  "/delhi/premium/sofa-prem/ananta-3-seater-sectional-sofa",
  "/delhi/premium/sofa-prem/contemporary-grey-sofa-1",
  "/delhi/premium/sofa-prem/crimson-bloosom-sofa-1",
  "/delhi/premium/sofa-prem/dune-elegance-sofa-1",
  "/delhi/premium/sofa-prem/electric-recliner",
  "/delhi/premium/sofa-prem/emperor-recliner-sofa-1",
  "/delhi/premium/sofa-prem/empress-sectional-sofa-1",
  "/delhi/premium/sofa-prem/imperial-corner-sofa-1",
  "/delhi/premium/sofa-prem/imperial-grandeur-sofa-1",
  "/delhi/premium/sofa-prem/ivory-heaven-sofa-1",
  "/delhi/premium/sofa-prem/l-shape-sofa-cum-bed",
  "/delhi/premium/sofa-prem/riveria-lounge-sofa-1",
  "/delhi/premium/sofa-prem/rosewater-serenade-sofa-1",
  "/delhi/premium/sofa-prem/sapphire-grand-sofa-1",
  "/delhi/premium/sofa-prem/savoy-corner-sofa-1",
  "/delhi/premium/sofa-prem/slate-citadel-sofa-1",
  "/delhi/premium/sofa-prem/solistice-sectional-sofa-1",
  "/delhi/premium/sofa-prem/valencia-sette-1",
  "/delhi/premium/table-prem",
  "/delhi/premium/table-prem/Solid-Wood-Cane-Craft-TV-Unit",
  "/delhi/seasonal",
  "/delhi/seasonal/1.5-ton-haier-AC-seasonal",
  "/delhi/seasonal/1.5-ton-haier-AC-seasonal/1.5 TON SPLIT",
  "/delhi/seasonal/1.5-ton-haier-AC-seasonal/spit-ac",
  "/delhi/seasonal/1.5-ton-haier-AC-seasonal/window-ac",
  "/delhi/seasonal/air-purifier",
  "/delhi/seasonal/air-purifier/air-purifier-bepure",
  "/delhi/seasonal/air-purifier/honeywell-air-purifier",
  "/delhi/seasonal/cooler-seasonal",
  "/delhi/seasonal/cooler-seasonal/cooler-0-1",
  "/delhi/seasonal/geyser-seasonal",
  "/delhi/seasonal/heater-seasonal",
  "/delhi/seasonal/heater-seasonal/Induction Cooktop",
  "/delhi/seasonal/heater-seasonal/room-heater",
  "/faq",
  "/gurgaon",
  "/gurgaon/appliance",
  "/gurgaon/appliance/1.5-ton-haier-AC",
  "/gurgaon/appliance/1.5-ton-haier-AC/1.5-ton-haier-AC",
  "/gurgaon/appliance/Fire-TV-Stick-Lite",
  "/gurgaon/appliance/Fire-TV-Stick-Lite/fire-tv-stick-light",
  "/gurgaon/appliance/air-cooler",
  "/gurgaon/appliance/air-cooler/air-cooler",
  "/gurgaon/appliance/air-purifier",
  "/gurgaon/appliance/bed/haier-55-inch-4K-UHD-LED-TV-0-1",
  "/gurgaon/appliance/geyser",
  "/gurgaon/appliance/geyser/crompton-arno-neo",
  "/gurgaon/appliance/heater",
  "/gurgaon/appliance/induction",
  "/gurgaon/appliance/inverter",
  "/gurgaon/appliance/inverter/double-battery-inverter",
  "/gurgaon/appliance/inverter/single-battery-inverter",
  "/gurgaon/appliance/microwave",
  "/gurgaon/appliance/microwave/solo-microwave-0-6",
  "/gurgaon/appliance/refrigerator",
  "/gurgaon/appliance/refrigerator/double-door-refrigerator-0-9",
  "/gurgaon/appliance/refrigerator/single-door-refrigerator-0-9",
  "/gurgaon/appliance/ro",
  "/gurgaon/appliance/ro/Kent-ultra-storage-0-1",
  "/gurgaon/appliance/ro/Livpure-Allura-premia-water-purifier-0-1",
  "/gurgaon/appliance/television",
  "/gurgaon/appliance/television/led-32-inch-0-1",
  "/gurgaon/appliance/television/led-40-inch-0-9",
  "/gurgaon/appliance/washing-machine",
  "/gurgaon/appliance/washing-machine/semi_automatic_machine_6kg",
  "/gurgaon/appliance/washing-machine/washing-machine-fully-auto-top-load-0-6",
  "/gurgaon/expressDelivery",
  "/gurgaon/expressDelivery/chair/high-back-office-chair",
  "/gurgaon/expressDelivery/chair/wooden-chair-0-1",
  "/gurgaon/expressDelivery/heater-seasonal/Induction Cooktop",
  "/gurgaon/expressDelivery/sofa-prem/l-shape-sofa-cum-bed",
  "/gurgaon/expressDelivery/sofa/killim-beige-1-seater-sofa-0-1",
  "/gurgaon/expressDelivery/sofa/latte-2-seater-sofa-0-1",
  "/gurgaon/expressDelivery/sofa/pebble-grey-l-shaped-sofa-0-1",
  "/gurgaon/expressDelivery/sofa/sapphire-blue-1-seater-sofa-0-1",
  "/gurgaon/expressDelivery/sofa/single-futon-with-mattress-0-1",
  "/gurgaon/expressDelivery/storage/bookshelf-0-1",
  "/gurgaon/expressDelivery/table/4-seater-sheesham-dining-set",
  "/gurgaon/expressDelivery/table/6-seater-dining-table-0-1",
  "/gurgaon/expressDelivery/table/dressing-table-0-1",
  "/gurgaon/expressDelivery/table/wooden-bedside-table-0-1",
  "/gurgaon/expressDelivery/television/led-32-inch-0-1",
  "/gurgaon/expressDelivery/television/led-40-inch-0-9",
  "/gurgaon/expressDelivery/work-from-home/work-from-home-new-two",
  "/gurgaon/expressDelivery/work-from-home/work-from-home-package",
  "/gurgaon/furniture",
  "/gurgaon/furniture/bed",
  "/gurgaon/furniture/bed/arch-double-storage-bed-0-1",
  "/gurgaon/furniture/bed/arch-premium-double-storage-bed-0-1",
  "/gurgaon/furniture/bed/tuft-double-bed-0-1",
  "/gurgaon/furniture/bed/tuft-double-storage-bed-0-1",
  "/gurgaon/furniture/bed/tuft-double-storage-bed-0-2",
  "/gurgaon/furniture/bed/tuft-double-storage-bed-0-3",
  "/gurgaon/furniture/bed/tuft-single-storage-bed-0-1",
  "/gurgaon/furniture/bed/vega-double-bed-0-1",
  "/gurgaon/furniture/bed/vega-double-storage-bed-0-1",
  "/gurgaon/furniture/bed/vega-single-bed-0-1",
  "/gurgaon/furniture/chair",
  "/gurgaon/furniture/chair/FlexPro Chair",
  "/gurgaon/furniture/chair/abstract-wing-chair-0-1",
  "/gurgaon/furniture/chair/airflow_pro_office_chair",
  "/gurgaon/furniture/chair/evon-office-chair-0-1",
  "/gurgaon/furniture/chair/high-back-office-chair",
  "/gurgaon/furniture/chair/nitro-gt-gaming-chair",
  "/gurgaon/furniture/chair/wooden-chair-0-1",
  "/gurgaon/furniture/mattress",
  "/gurgaon/furniture/mattress/double-mattress-0-1",
  "/gurgaon/furniture/mattress/premium-double-mattress-0-1",
  "/gurgaon/furniture/mattress/premium-single-mattress-0-1",
  "/gurgaon/furniture/mattress/single-mattress-0-1",
  "/gurgaon/furniture/recliner",
  "/gurgaon/furniture/recliner/relaxPro-recliner-chair",
  "/gurgaon/furniture/sofa",
  "/gurgaon/furniture/sofa/cyan-l-shaped-sofa-0-1",
  "/gurgaon/furniture/sofa/killim-beige-1-seater-sofa-0-1",
  "/gurgaon/furniture/sofa/killim-beige-3-seater-sofa-0-1",
  "/gurgaon/furniture/sofa/killim-beige-5-seater-sofa-(3+1+1)-0-1",
  "/gurgaon/furniture/sofa/latte-1-seater-sofa-0-1",
  "/gurgaon/furniture/sofa/latte-2-seater-sofa-0-1",
  "/gurgaon/furniture/sofa/latte-3-seater-sofa-0-1",
  "/gurgaon/furniture/sofa/latte-4-seater-sofa-(2+1+1)-0-1",
  "/gurgaon/furniture/sofa/latte-5-seater-sofa-(3+1+1)-0-1",
  "/gurgaon/furniture/sofa/latte-5-seater-sofa-(3+2)-0-1",
  "/gurgaon/furniture/sofa/pebble-grey-l-shaped-sofa-0-1",
  "/gurgaon/furniture/sofa/sapphire-blue-1-seater-sofa-0-1",
  "/gurgaon/furniture/sofa/sapphire-blue-3-seater-sofa-0-1",
  "/gurgaon/furniture/sofa/sapphire-blue-5-seater-sofa-(3+1+1)-0-1",
  "/gurgaon/furniture/sofa/single-futon-with-mattress-0-1",
  "/gurgaon/furniture/sofa/sofa-cum-bed",
  "/gurgaon/furniture/storage",
  "/gurgaon/furniture/storage/bookshelf-0-1",
  "/gurgaon/furniture/storage/bookshelf-divider-0-1",
  "/gurgaon/furniture/storage/shoerack-0-1",
  "/gurgaon/furniture/storage/wardrobe-0-1",
  "/gurgaon/furniture/storage/wardrobe-with-mirror-0-1",
  "/gurgaon/furniture/table",
  "/gurgaon/furniture/table/4-seater-dining-set-0-1",
  "/gurgaon/furniture/table/4-seater-sheesham-dining-set",
  "/gurgaon/furniture/table/6-seater-dining-table-0-1",
  "/gurgaon/furniture/table/caramel-side-table-0-1",
  "/gurgaon/furniture/table/center-table-0-1",
  "/gurgaon/furniture/table/dressing-table-0-1",
  "/gurgaon/furniture/table/study-table-0-1",
  "/gurgaon/furniture/table/wenge-side-table-0-1",
  "/gurgaon/furniture/table/wooden-bedside-table-0-1",
  "/gurgaon/furniture/television/signature-series-console-1",
  "/gurgaon/package",
  "/gurgaon/package/appliances-package",
  "/gurgaon/package/appliances-package/appliances-only-1",
  "/gurgaon/package/bhk",
  "/gurgaon/package/bhk/1-bhk-essentials",
  "/gurgaon/package/bhk/1-bhk-furnitures-only-1",
  "/gurgaon/package/bhk/2-bhk-essentials",
  "/gurgaon/package/drawing-room-package",
  "/gurgaon/package/family",
  "/gurgaon/package/family/couple-cozy-premium-combo",
  "/gurgaon/package/family/couples-cozy-combo-affordable-1",
  "/gurgaon/package/family/family-essentials-1",
  "/gurgaon/package/living-room",
  "/gurgaon/package/living-room/affordable-living-room-combo",
  "/gurgaon/package/living-room/full-bedroom-furniture-affordable-1",
  "/gurgaon/package/living-room/full-bedroom-furniture-premium-1",
  "/gurgaon/package/living-room/premium-living-room-1",
  "/gurgaon/package/study-cool-combo-package",
  "/gurgaon/package/study-cool-combo-package/budget-friendly-living-combo-1",
  "/gurgaon/package/work-from-home",
  "/gurgaon/package/work-from-home/work-from-home-new-two",
  "/gurgaon/package/work-from-home/work-from-home-package",
  "/gurgaon/premium",
  "/gurgaon/premium/bed-prem",
  "/gurgaon/premium/bed-prem/Aura-Double-Bed",
  "/gurgaon/premium/bed-prem/Comso-Double-Bed",
  "/gurgaon/premium/bed-prem/Dream-Lux-Premium-Double-Bed",
  "/gurgaon/premium/bed-prem/Shirley-Double-Bed",
  "/gurgaon/premium/bed-prem/Somnia-Supreme-Premium-Double-Bed",
  "/gurgaon/premium/bed-prem/Teak-Cane-Double-Bed-Ratan",
  "/gurgaon/premium/bed-prem/Zenith-Premium-Double-Bed",
  "/gurgaon/premium/bed-prem/Ziva-Double-Bed",
  "/gurgaon/premium/chair-prem",
  "/gurgaon/premium/chair-prem/Premium-Cane-Cushioned-chair",
  "/gurgaon/premium/premium-mattress",
  "/gurgaon/premium/premium-mattress/Orthopedic-Mattress",
  "/gurgaon/premium/sofa-prem",
  "/gurgaon/premium/sofa-prem/Chesterfield-3-seater-Fabric-Sofa",
  "/gurgaon/premium/sofa-prem/Chesterfield-3-seater-Leather-Sofa",
  "/gurgaon/premium/sofa-prem/Dual-shade-Sofa",
  "/gurgaon/premium/sofa-prem/Premium-Eterna-Plush-Sofa",
  "/gurgaon/premium/sofa-prem/Urban-Elegance-Sofa",
  "/gurgaon/premium/sofa-prem/aegean-chase-sofa-1",
  "/gurgaon/premium/sofa-prem/ananta-3-seater-sectional-sofa",
  "/gurgaon/premium/sofa-prem/contemporary-grey-sofa-1",
  "/gurgaon/premium/sofa-prem/crimson-bloosom-sofa-1",
  "/gurgaon/premium/sofa-prem/dune-elegance-sofa-1",
  "/gurgaon/premium/sofa-prem/electric-recliner",
  "/gurgaon/premium/sofa-prem/emperor-recliner-sofa-1",
  "/gurgaon/premium/sofa-prem/empress-sectional-sofa-1",
  "/gurgaon/premium/sofa-prem/imperial-corner-sofa-1",
  "/gurgaon/premium/sofa-prem/imperial-grandeur-sofa-1",
  "/gurgaon/premium/sofa-prem/ivory-heaven-sofa-1",
  "/gurgaon/premium/sofa-prem/l-shape-sofa-cum-bed",
  "/gurgaon/premium/sofa-prem/riveria-lounge-sofa-1",
  "/gurgaon/premium/sofa-prem/rosewater-serenade-sofa-1",
  "/gurgaon/premium/sofa-prem/sapphire-grand-sofa-1",
  "/gurgaon/premium/sofa-prem/savoy-corner-sofa-1",
  "/gurgaon/premium/sofa-prem/slate-citadel-sofa-1",
  "/gurgaon/premium/sofa-prem/solistice-sectional-sofa-1",
  "/gurgaon/premium/sofa-prem/valencia-sette-1",
  "/gurgaon/premium/table-prem",
  "/gurgaon/premium/table-prem/Solid-Wood-Cane-Craft-TV-Unit",
  "/gurgaon/seasonal",
  "/gurgaon/seasonal/1.5-ton-haier-AC-seasonal",
  "/gurgaon/seasonal/1.5-ton-haier-AC-seasonal/1.5 TON SPLIT",
  "/gurgaon/seasonal/1.5-ton-haier-AC-seasonal/spit-ac",
  "/gurgaon/seasonal/1.5-ton-haier-AC-seasonal/window-ac",
  "/gurgaon/seasonal/air-purifier",
  "/gurgaon/seasonal/air-purifier/air-purifier-bepure",
  "/gurgaon/seasonal/air-purifier/honeywell-air-purifier",
  "/gurgaon/seasonal/cooler-seasonal",
  "/gurgaon/seasonal/cooler-seasonal/cooler-0-1",
  "/gurgaon/seasonal/geyser-seasonal",
  "/gurgaon/seasonal/heater-seasonal",
  "/gurgaon/seasonal/heater-seasonal/Induction Cooktop",
  "/gurgaon/seasonal/heater-seasonal/room-heater",
  "/privacy-policy",
  "/terms-conditions"
];

export default seoRoutes;
